import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { color, image } from '@/theme';
import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import { PrimaryButton } from '@/components/button';
import { RegularText } from '@/components/text';
import { Image } from '@/components/shared';
import { SelectInput } from '@/components/input';
import { ButtonContent, ButtonWrapper } from '@/pages/inquiry/inquryStyles';
import { InquiryTerms } from '@/pages/inquiry';
import {
  useGetArenaEventCategory,
  useGetBusinessCategory,
  useGetMeetingEventCategory,
} from '@/hooks/CommonRequests';

const InquiryStepOne = ({ watch, control, errors, setValue }) => {
  const { search } = useLocation();
  const navigate = useNavigate();

  const lang = localStorage.getItem(LOCAL_LANGUAGE) || 'en';
  const baseUrl = lang !== null ? `/${lang}` : '';

  const categoryParams = new URLSearchParams(search).get('category');

  const { data: businessCategory } = useGetBusinessCategory();
  const { data: arenaEventCategory } = useGetArenaEventCategory();
  const { data: meetingEventCategory } = useGetMeetingEventCategory();

  useEffect(() => {
    if (categoryParams) {
      setValue(
        'business_key',
        businessCategory?.find((el) => el.code_id === categoryParams)?.code_value
      );
    }
  }, [businessCategory, categoryParams, setValue]);

  return (
    <>
      <SelectInput
        control={control}
        errors={errors}
        name="business_key"
        arr={businessCategory}
        label="lang-business"
        required
        disabled
      />

      <SelectInput
        control={control}
        errors={errors}
        name="event_type_key"
        arr={watch('business_key') === '1' ? arenaEventCategory : meetingEventCategory}
        label="lang-type-of-event"
        required
      />

      <div style={{ marginTop: '2rem' }}>
        <InquiryTerms control={control} errors={errors} setValue={setValue} />
      </div>

      <ButtonWrapper>
        <PrimaryButton type="button" onClick={() => navigate(`${baseUrl}/inquiry`)}>
          <ButtonContent>
            <Image src={image.arrowLeft.default} width="1.8rem" height="1.4rem" />
            <RegularText id="lang-prev" color={color.base_white} />
          </ButtonContent>
        </PrimaryButton>

        <PrimaryButton type="submit" width="92%">
          <ButtonContent>
            <RegularText id="lang-inquiry-next" color={color.base_white} />
            <Image src={image.arrowRight.default} width="1.8rem" height="1.4rem" />
          </ButtonContent>
        </PrimaryButton>
      </ButtonWrapper>
    </>
  );
};

export default InquiryStepOne;
